import { Injectable, signal, WritableSignal } from '@angular/core';

@Injectable({
	providedIn: 'root',
})
export class ProfileSignal {
	public requestUpdateIntervalOn: WritableSignal<boolean> = signal(true);

	constructor() {
		if (localStorage.getItem('requestUpdateIntervalOn') === null) {
			localStorage.setItem('requestUpdateIntervalOn', 'true');
		}
		this.requestUpdateIntervalOn.set(localStorage.getItem('requestUpdateIntervalOn') === 'true');
	}

	setStorage(key: string, value: any): void {
		localStorage.setItem(key, value);
	}
}
